import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CalendarIcon } from "lucide-react";
import { Customer } from "@/hooks/useCustomers";
import { VisitFormContent, VisitFormData } from "./VisitFormContent";

// Re-export the type for backwards compatibility
export type { VisitFormData } from "./VisitFormContent";

interface VisitFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  values: VisitFormData;
  onFieldChange: (field: keyof VisitFormData, value: any) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isLoading: boolean;
  showDeleteButton?: boolean;
  onDelete?: () => void;
  showNoShowButton?: boolean;
  onNoShow?: () => void;
  currentStatus?: string | null;
  selectedCustomer?: Customer | null;
  onCustomerSelect?: (customer: Customer | null) => void;
  visitServiceIds: string[];
  visitTeamMemberIds: string[];
  onVisitChange: (serviceIds: string[], teamMemberIds: string[]) => void;
  filteredTeamMemberIds?: string[];
  prefilledCustomer?: Customer;
  isEditingVisit?: boolean;
}

export const VisitForm = ({
  open,
  onOpenChange,
  title,
  values,
  onFieldChange,
  onSubmit,
  onCancel,
  isLoading,
  showDeleteButton = false,
  onDelete,
  showNoShowButton = false,
  onNoShow,
  currentStatus = null,
  selectedCustomer: _selectedCustomer,
  onCustomerSelect = () => { },
  visitServiceIds,
  visitTeamMemberIds,
  onVisitChange,
  filteredTeamMemberIds: _filteredTeamMemberIds = [],
  prefilledCustomer,
  isEditingVisit = false
}: VisitFormProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CalendarIcon className="h-5 w-5" />
            {title}
          </DialogTitle>
        </DialogHeader>

        <VisitFormContent
          values={values}
          onFieldChange={onFieldChange}
          onSubmit={onSubmit}
          onCancel={onCancel}
          isLoading={isLoading}
          showDeleteButton={showDeleteButton}
          onDelete={onDelete}
          showNoShowButton={showNoShowButton}
          onNoShow={onNoShow}
          currentStatus={currentStatus}
          onCustomerSelect={onCustomerSelect}
          visitServiceIds={visitServiceIds}
          visitTeamMemberIds={visitTeamMemberIds}
          onVisitChange={onVisitChange}
          prefilledCustomer={prefilledCustomer}
          isEditingVisit={isEditingVisit}
        />
      </DialogContent>
    </Dialog>
  );
};
